import React from "react";
import { Button, IconButton, Menu, MenuItem } from "@mui/material";
import { Help as HelpIcon } from "@mui/icons-material";
import { styled } from "@mui/material/styles";

import { i18n } from "src/i18n";

export function HelpMenu() {
  /**
   * Functions
   */
  function handleClick() {
    window.open(window._env_.REACT_APP_DOCS_URL, "_blank");
  }

  // render the component
  return render();

  function render() {
    return (
      <Styles>
        <IconButton color="default" onClick={handleClick} size="large">
          <HelpIcon color="action" />
        </IconButton>
      </Styles>
    );
  }
}

const Styles = styled("div")`
  * {
    text-transform: capitalize;
  }
`;
